import React from 'react';
import { ButtonPrimary, ButtonSecondary } from './Buttons';
import styled from 'styled-components';
import { EnrollmentEndsAt } from '@Constants';

export function JoinPrimary(props) {
  return (
    <Join Button={StyledPrimary} {...props}>
      {props.children}
    </Join>
  );
}

export function JoinSecondary(props) {
  return (
    <Join Button={StyledSecondary} {...props}>
      {props.children}
    </Join>
  );
}

function Join(props) {
  let theProps = { ...props };
  let url = 'https://the167.mykajabi.com/offers/eLaMztop';
  let text = `Join Now`;
  if (EnrollmentEndsAt < new Date()) {
    url = 'https://the167.mykajabi.com/waiting-list';
    theProps.href = url;
    text = 'Join Waitlist';
  }

  let { Button, ...otherProps } = theProps;

  return (
    <Button href={url} {...otherProps}>
      {props.children || text}
    </Button>
  );
}

const StyledPrimary = styled(ButtonPrimary)``;

const StyledSecondary = styled(ButtonSecondary)``;



// WEBPACK FOOTER //
// ./src/components-legacy/Buttons/JoinNow.js